import ButtonIconH from "./ButtonIconH";
import moment from "moment";
import "../css/GlassesHistoryBox.css";
import { useEffect, useState } from "react";
import { formatValueUnit } from "../js/utils";

export default function GlassesHistoryBox({ data, onOpen }) {
  const [totalExtras, setTotalExtras] = useState(0);

  useEffect(() => {
    const total = data.extras.reduce(
      (acc, extra) => acc + (parseFloat(extra.total) || 0),
      0,
    );
    setTotalExtras(total);
  }, [data.extras]);

  return (
    <div className="history-box">
      <div className="history-box-header">
        <div
          className="history-box-header-fields"
          style={{ padding: "0px 20px", height: "30px" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Tipo</span>
            <span>{data.gafasSol ? "Sol" : "Vista"}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Fecha</span>
            <span>{moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Realizada por</span>
            <span>{data.empleado}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Tipo ficha</span>
            <span>{data.tipoFichaDescripcion}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Tipo gafa</span>
            <span>{data.tipoGafaDescripcion}</span>
          </div>
        </div>
        <div style={{ padding: "5px" }}>
          <ButtonIconH text="Mostrar" small onClick={onOpen}></ButtonIconH>
        </div>
      </div>
      <span className="history-box-tag history-box-title-bg">Montura</span>
      <div className="history-box-content">
        <div className="history-box-header-fields">
          <div className="history-box-header-field">
            <span className="history-box-tag">Proveedor</span>
            <span>{data.datosMontura.nombreProveedor}</span>
            <span className="history-box-tag">Código</span>
            <span>{data.datosMontura.codigo}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Total</span>
            <span>{formatValueUnit(data.datosMontura.total, "€")}</span>
          </div>
        </div>
        <div
          className="history-box-content-header"
          style={{ gridTemplateColumns: "repeat(9, 1fr)" }}
        >
          <span className="history-box-tag">Marca</span>
          <span className="history-box-tag">Modelo</span>
          <span className="history-box-tag">Color</span>
          <span className="history-box-tag">Color lente</span>
          <span className="history-box-tag">Calibre</span>
          <span className="history-box-tag">Puente</span>
          <span className="history-box-tag">Varilla</span>
          <span className="history-box-tag">Material</span>
          <span className="history-box-tag">Forma</span>
        </div>
        <div
          className="history-box-content-data"
          style={{
            gridTemplateColumns: "repeat(9, 1fr)",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
          }}
        >
          <span className="history-box-data">{data.datosMontura.marca}</span>
          <span className="history-box-data">{data.datosMontura.modelo}</span>
          <span className="history-box-data">{data.datosMontura.color}</span>
          <span className="history-box-data">
            {data.datosMontura.colorCristal}
          </span>
          <span className="history-box-data">{data.datosMontura.calibre1}</span>
          <span className="history-box-data">{data.datosMontura.calibre2}</span>
          <span className="history-box-data">{data.datosMontura.varilla}</span>
          <span className="history-box-data">{data.datosMontura.material}</span>
          <span className="history-box-data">{data.datosMontura.forma}</span>
        </div>
      </div>
      <span className="history-box-tag history-box-title-bg">Lente OD</span>
      <div className="history-box-content">
        <div className="history-box-header-fields">
          <div className="history-box-header-field">
            <span className="history-box-tag">Proveedor</span>
            <span>{data.datosLenteOD.nombreProveedor}</span>
            <span className="history-box-tag">Código</span>
            <span>{data.datosLenteOD.codigo}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Total</span>
            <span>{formatValueUnit(data.datosLenteOD.total, "€")}</span>
          </div>
        </div>
        <div
          className="history-box-content-header"
          style={{ gridTemplateColumns: "repeat(6, 1fr)" }}
        >
          <span className="history-box-tag">Marca</span>
          <span className="history-box-tag">Nombre comercial</span>
          <span className="history-box-tag">Material</span>
          <span className="history-box-tag">Tipo</span>
          <span className="history-box-tag">Color</span>
          <span className="history-box-tag">Tratamiento</span>
        </div>
        <div
          className="history-box-content-data"
          style={{
            gridTemplateColumns: "repeat(6, 1fr)",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
          }}
        >
          <span className="history-box-data">{data.datosLenteOD.marca}</span>
          <span className="history-box-data">
            {data.datosLenteOD.nombreComercial}
          </span>
          <span className="history-box-data">{data.datosLenteOD.material}</span>
          <span className="history-box-data">{data.datosLenteOD.tipo}</span>
          <span className="history-box-data">{data.datosLenteOD.color}</span>
          <span className="history-box-data">
            {data.datosLenteOD.tratamiento}
          </span>
        </div>
      </div>
      <span className="history-box-tag history-box-title-bg">Lente OI</span>
      <div className="history-box-content">
        <div className="history-box-header-fields">
          <div className="history-box-header-field">
            <span className="history-box-tag">Proveedor</span>
            <span>{data.datosLenteOI.nombreProveedor}</span>
            <span className="history-box-tag">Código</span>
            <span>{data.datosLenteOI.codigo}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Total</span>
            <span>{formatValueUnit(data.datosLenteOI.total, "€")}</span>
          </div>
        </div>
        <div
          className="history-box-content-header"
          style={{ gridTemplateColumns: "repeat(6, 1fr)" }}
        >
          <span className="history-box-tag">Marca</span>
          <span className="history-box-tag">Nombre comercial</span>
          <span className="history-box-tag">Material</span>
          <span className="history-box-tag">Tipo</span>
          <span className="history-box-tag">Color</span>
          <span className="history-box-tag">Tratamiento</span>
        </div>
        <div
          className="history-box-content-data"
          style={{
            gridTemplateColumns: "repeat(6, 1fr)",
          }}
        >
          <span className="history-box-data">{data.datosLenteOI.marca}</span>
          <span className="history-box-data">
            {data.datosLenteOI.nombreComercial}
          </span>
          <span className="history-box-data">{data.datosLenteOI.material}</span>
          <span className="history-box-data">{data.datosLenteOI.tipo}</span>
          <span className="history-box-data">{data.datosLenteOI.color}</span>
          <span className="history-box-data">
            {data.datosLenteOI.tratamiento}
          </span>
        </div>
      </div>
      <span className="history-box-tag history-box-title-bg">
        Extras ({data.extras.length})
      </span>
      <div className="history-box-content">
        {data.extras.length > 0 && (
          <>
            <div
              className="history-box-content-header"
              style={{
                gridTemplateColumns: "repeat(3, 200px)",
                justifyContent: "flex-start",
              }}
            >
              <span className="history-box-tag">Código</span>
              <span className="history-box-tag">Descripción</span>
              <span className="history-box-tag">Total</span>
            </div>
            {data.extras.map((e, i) => (
              <div
                key={i}
                className="history-box-content-data"
                style={{
                  gridTemplateColumns: "repeat(3, 200px)",
                  justifyContent: "flex-start",
                }}
              >
                <span className="history-box-data">{e.codigo}</span>
                <span className="history-box-data">{e.descripcion}</span>
                <span className="history-box-data">
                  {formatValueUnit(e.total, "€")}
                </span>
              </div>
            ))}
          </>
        )}
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#ffffff", justifyContent: "flex-end" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Total extras</span>
            <span>{formatValueUnit(totalExtras, "€")}</span>
          </div>
        </div>
        <div
          className="history-box-header-fields"
          style={{
            padding: "0px 20px",
            height: "30px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Total ficha</span>
            <span>{formatValueUnit(data.precioTotal, "€")}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
